<template>
    <component :is="tagName" :class="classes">
        <input v-bind="$attrs" :checked="active" class="kl-ol-map-base-layer-toggle__radio" name="base-layer-toggle" type="radio" @change="emitSelect" />
        <div class="kl-ol-map-base-layer-toggle__body">
            <p class="kl-ol-map-base-layer-toggle__body__label">
                <span>{{ title }}</span>
            </p>
            <img
                v-if="image"
                :alt="image.alt"
                :src="image.src"
                :srcset="image.srcset"
                class="kl-ol-map-base-layer-toggle__body__image"
            />
        </div>
    </component>
</template>

<script src="./kl-ol-map-base-layer-toggle.ts"></script>
